import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { AuthProvider } from 'react-oidc-context';
import App from './App';
import { ErrorFallback } from './components/error-fallback';
import { oidcConfig } from './config/auth-config';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider {...oidcConfig}>
      <ErrorBoundary fallbackRender={({ error }) => <ErrorFallback error={error} />}>
        <App />
      </ErrorBoundary>
    </AuthProvider>
  </StrictMode>,
);
